import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { HomePage } from '@/pages/HomePage';
import { CreatorPage } from '@/pages/CreatorPage';
import { AboutPage } from '@/pages/AboutPage';
import { MikaelaPage } from '@/pages/MikaelaPage';
import { SharedCharacterGate } from '@/components/SharedCharacterGate';

export default function App() {
  return (
    <SharedCharacterGate>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/create/:type" element={<CreatorPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/mikaela" element={<MikaelaPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </SharedCharacterGate>
  );
}
